import React, {FC} from 'react';

import {FrontEvent} from '../../../../../libs/shared/helpers/src/react/reactHelpers';
import {DropdownItem} from '../../../../../libs/shared/ui/src/components/dropdowns/dropdownItem';
import {DropdownItemCheckbox} from '../../../../../libs/shared/ui/src/components/dropdowns/dropdownItemCheckbox';
import {FilterRow} from '../common/types';

interface FilterDropdownRowProps {
  row: FilterRow;
  // If true, each row will render a checkbox indicating it's selection state.
  isMultiSelect: boolean;
  shouldCloseOnSelection: boolean;
}

export const FilterDropdownRow: FC<FilterDropdownRowProps> = ({
  row,
  isMultiSelect,
  shouldCloseOnSelection,
}) => {
  if (row.isException) {
    return <>{row.renderer()}</>;
  }

  const onSelect = (event: FrontEvent) => {
    if (!shouldCloseOnSelection) {
      event.preventDefault();
    } // Keep the dropdown open.

    row.onSelect();
  };

  return (
    <DropdownItem
      isChecked={row.isSelected}
      onSelect={onSelect}
      renderRightContent={
        isMultiSelect ? () => <DropdownItemCheckbox isChecked={row.isSelected} /> : undefined
      }
      renderTooltip={row.renderTooltip}
      isDisabled={row.isDisabled}
    >
      {row.renderer()}
    </DropdownItem>
  );
};
